import { Action } from '../../types/Action';
import { Audience } from '../../types/digital-audience/DigitalAudience';

export enum DigitalAudienceDashboardActionsType {
  SET_DIGITAL_AUDIENCE_DASHBOARD_AUDIENCES = 'Set digital audience dashboard audiences',
  SET_DIGITAL_AUDIENCE_AUTO_REFRESH_UPDATING = 'Set digital audience auto refresh updating',
  TOGGLE_AUDIENCE_AUTO_REFRESH = 'Toggle audience auto refresh',
}

export const setDigitalAudienceDashboardAudiences = (audiences: Audience[]): Action => ({
  type: DigitalAudienceDashboardActionsType.SET_DIGITAL_AUDIENCE_DASHBOARD_AUDIENCES,
  payload: { audiences: audiences },
});

export const setDigitalAudienceAutoRefreshUpdating = (
  audienceId: string,
  value: boolean,
): Action => ({
  type: DigitalAudienceDashboardActionsType.SET_DIGITAL_AUDIENCE_AUTO_REFRESH_UPDATING,
  payload: { audienceId: audienceId, isUpdating: value },
});

export const toggleAudienceAutoRefresh = (audienceId: string): Action => ({
  type: DigitalAudienceDashboardActionsType.TOGGLE_AUDIENCE_AUTO_REFRESH,
  payload: { audienceId: audienceId },
});

export type DigitalAudienceDashboardActions = ReturnType<
  | typeof setDigitalAudienceDashboardAudiences
  | typeof setDigitalAudienceAutoRefreshUpdating
  | typeof toggleAudienceAutoRefresh
>;
